import { DI, ILogger, ConsoleSink, IPlatform, LoggerConfiguration, Registration } from '@aurelia/kernel';
import { BrowserPlatform } from '@aurelia/platform-browser';
const PLATFORM = BrowserPlatform.getOrCreate(globalThis);
const staticContainer = DI.createContainer();
staticContainer.register(Registration.instance(IPlatform, Registration));
staticContainer.register(LoggerConfiguration.create({ sinks: [ConsoleSink], level: 5 /* LogLevel.fatal */ }));
export const log = staticContainer.get(ILogger).scopeTo('iaAnyware');
